
import { Shell } from "@/components/layout/Shell";
import { ContractTypeForm } from "@/components/contract-types/ContractTypeForm";
import { useTranslation } from "react-i18next";

export default function ContractTypeCreatePage() {
  const { t } = useTranslation();

  return (
    <Shell>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">{t('createNewContractType')}</h1>
          <p className="text-muted-foreground mt-2">
            {t('addNewContractType')}
          </p>
        </div>

        <ContractTypeForm mode="create" />
      </div>
    </Shell>
  );
}
